/**
 * A pill-style segmented toggle. The selected segment gets an indigo
 * background; the rest are muted text on a subtle track.
 *
 * Props:
 *   options   { value, label }[]   — the segments (value can be string or number)
 *   value     any                  — the currently selected value
 *   onChange  (value) => void       — called with the picked segment's value
 *   className string                — extra classes on the wrapper
 */
export default function SegmentedControl({ options, value, onChange, className = "" }) {
  return (
    <div
      className={`flex rounded-lg overflow-hidden border border-palette-gray-divider bg-palette-gray-subtle text-sm font-medium ${className}`.trim()}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-4 py-2 transition-colors whitespace-nowrap ${
            value === opt.value
              ? "bg-palette-indigo-badge text-white shadow-sm"
              : "text-palette-gray-secondary hover:text-palette-gray-heading"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
